import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { footerAPI } from '../../services/footerAPI';

interface FooterState {
  footer: {
    address?: string;
    mobileno?: string;
    instagramlink?: string;
    facebooklink?: string;
    twitterlink?: string;
    description?: string;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: FooterState = {
  footer: {},
  isLoading: false,
  error: null,
};

export const fetchFooter = createAsyncThunk(
  'footer/fetchFooter',
  async () => {
    return await footerAPI.getFooter();
  }
);

export const updateFooter = createAsyncThunk(
  'footer/updateFooter',
  async (data: {
    address?: string;
    mobileno?: string;
    instagramlink?: string;
    facebooklink?: string;
    twitterlink?: string;
    description?: string;
  }) => {
    return await footerAPI.updateFooter(data);
  }
);

const footerSlice = createSlice({
  name: 'footer',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFooter.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFooter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.footer = action.payload.data || {};
      })
      .addCase(fetchFooter.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch footer';
      })
      .addCase(updateFooter.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFooter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.footer = { ...state.footer, ...action.payload.data };
      })
      .addCase(updateFooter.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to update footer';
      });
  },
});

export const { clearError } = footerSlice.actions;
export default footerSlice.reducer;